const LEGAL_AGREEMENTS = [
	{
		pathname: "/terms-and-conditions",
		field: "terms_and_conditions",
	},
	{
		pathname: "/privacy-policy",
		field: "privacy_policy",
	},
	{
		pathname: "/cookie-policy",
		field: "cookie_policy",
	},
] as const;

type LegalAgreementField = (typeof LEGAL_AGREEMENTS)[number]["field"];
type LegalAgreementCommunity = Partial<
	Record<LegalAgreementField, string | null | undefined>
>;

const findLegalAgreement = (pathname: string) =>
	LEGAL_AGREEMENTS.find(({ pathname: route }) => pathname.includes(route)) ??
	LEGAL_AGREEMENTS[2];

const hasCommunityLegalContent = (
	content: string | null | undefined,
): content is string => {
	if (typeof content !== "string") {
		return false;
	}

	const normalizedContent = content.trim().toLowerCase();
	return normalizedContent.length > 0 && normalizedContent !== "not_set";
};

export const getLegalAgreementContent = (
	pathname: string,
	community: LegalAgreementCommunity | undefined,
) => {
	const { field } = findLegalAgreement(pathname);
	return community?.[field] ?? undefined;
};

export const getPublicPolicyPaymentsEnabled = (isWhiteLabel: boolean) =>
	!isWhiteLabel;

export const isLegalAgreementAvailable = (
	pathname: string,
	community: LegalAgreementCommunity | undefined,
	isWhiteLabel: boolean,
) =>
	!isWhiteLabel ||
	hasCommunityLegalContent(getLegalAgreementContent(pathname, community));

export const getVisibleLegalAgreements = (
	community: LegalAgreementCommunity | undefined,
	isWhiteLabel: boolean,
) =>
	LEGAL_AGREEMENTS.filter(({ pathname }) =>
		isLegalAgreementAvailable(pathname, community, isWhiteLabel),
	);

export const getLegalAgreementUrls = (
	community: LegalAgreementCommunity | undefined,
	isWhiteLabel: boolean,
) => ({
	privacyPolicyUrl: isLegalAgreementAvailable(
		"/privacy-policy",
		community,
		isWhiteLabel,
	)
		? "/privacy-policy"
		: undefined,
	cookiePolicyUrl: isLegalAgreementAvailable(
		"/cookie-policy",
		community,
		isWhiteLabel,
	)
		? "/cookie-policy"
		: undefined,
});
